import { Modal, TextInput, Stack, Radio, Button } from '@mantine/core';
import { useForm } from '@mantine/form';
import { FocusButton } from 'src/components/common/Buttons/FocusButton';

interface CreateCouponModalProps {
  opened: boolean;
  onClose: () => void;
  onSubmit: (values: { name: string; percentOff?: number; amountOff?: number }) => void;
}

export const CreateCouponModal = ({ opened, onClose, onSubmit }: CreateCouponModalProps) => {
  const form = useForm({
    initialValues: {
      name: '',
      discountType: 'percent',
      discountValue: '',
    },
    validate: {
      name: (value) => (!value ? 'Name is required' : null),
      discountValue: (value) => {
        if (!value) return 'Discount value is required';
        if (isNaN(Number(value)) || Number(value) <= 0) return 'Must be a positive number';
        return null;
      },
    },
  });

  return (
    <Modal opened={opened} onClose={onClose} title="Create New Coupon">
      <form onSubmit={form.onSubmit((values) => {
        const payload = {
          name: values.name,
          ...(values.discountType === 'percent' 
            ? { percentOff: Number(values.discountValue) }
            : { amountOff: Number(values.discountValue) })
        };
        onSubmit(payload);
      })}>
        <Stack>
          <TextInput
            label="Coupon Name"
            placeholder="Enter coupon name"
            {...form.getInputProps('name')}
          />
          <Radio.Group
            label="Discount Type"
            {...form.getInputProps('discountType')}
          >
            <Radio value="percent" label="Percentage Off" />
            <Radio value="amount" label="Fixed Amount Off" />
          </Radio.Group>
          <TextInput
            label={form.values.discountType === 'percent' ? 'Percentage Off' : 'Amount Off ($)'}
            placeholder="Enter value"
            {...form.getInputProps('discountValue')}
          />
          <Button type="submit">
            Create Coupon
          </Button>
        </Stack>
      </form>
    </Modal>
  );
};